import * as React from 'react';
import classnames from 'classnames';
import LayoutBlock from './layout-block';
import Label from './label';
import OptionsModal from './dropdown/options-modal';
import Icon from './icon';
import * as Models from './dropdown/models';
import { useSignleSelect } from './dropdown/select.behavior';

import './dropdown.scss';

export type DropDownItemValue = Models.ItemValue;
export type DropDownOption<T, V extends Models.ItemValue> = Models.Option<T, V>;
export type DropDownSingleProps<T, V extends Models.ItemValue> = Models.SingleProps<T, V>;

const DropDown = <T, V extends Models.ItemValue>(props: DropDownSingleProps<T, V>) => {
	const behavior = useSignleSelect(props);
	let selectElement = React.useRef(null);

	return (
		<LayoutBlock className='l-drop-down'>
			{!!props.label && (
				<LayoutBlock className='l-drop-down-label'>
					{props.label}
					{!props.validate && <span className='l-drop-down-label-validate'>*</span>}
				</LayoutBlock>
			)}
			<div ref={selectElement} className={classnames('r-select', props.className)}>
				<LayoutBlock inline fill className='r-select-field'>
					<LayoutBlock verticalAlign='center' style={{ height: '25px' }} onClick={behavior.onShowOptions}>
						<Label className={classnames('r-select-text', { 'r-select-text-default': !behavior.displayValue })}>
							{!!behavior.displayValue ? behavior.displayValue : 'Select an option'}
						</Label>
						<div className='r-select-value-icon'>
							<Icon icon='caretDown' />
						</div>
					</LayoutBlock>
				</LayoutBlock>
			</div>

			<OptionsModal
				show={behavior.showOptions}
				options={behavior.options}
				onHideOptions={behavior.onHideOptions}
				onChange={behavior.onChange}
				containerRect={selectElement.current?.getBoundingClientRect()}
				isSelected={behavior.isSelected}
			/>
		</LayoutBlock>
	);
};

DropDown.defaultProps = {
	value: null,
	onChange: () => {
		return;
	},
	label: null,
	options: null,
};

export default DropDown;
